import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useLogoutStore } from '@lib/store';
import { PaletteUtils } from '@shared/utils';

export const Logout = () => {
  const logoutStore = useLogoutStore();

  const { t } = useTranslation();

  return (
    <div
      className={clsx(
        'cursor-pointer leading-[3.09] uppercase align-middle ml-auto max-[840px]:ml-0 max-[840px]:order-2 max-[840px]:text-sm max-[840px]:font-black max-[840px]:pl-5',
        PaletteUtils.isBordierPalette ? 'text-[#4d3b2c] hover:text-[#27272b] ' : 'text-[#dadada] hover:text-[#e5c496] text-[11px]',
      )}
      onClick={logoutStore.logout}
    >
      <span className='max-lg:hidden max-[840px]:!inline-block'>{t('buttons.logout')}</span>
      <svg
        className='inline-block h-[16px] ml-[9px] -mt-[3px] align-middle w-[14px]'
        xmlns='http://www.w3.org/2000/svg'
        width='16'
        height='14'
        viewBox='0 0 16 14'
      >
        <g fill='currentColor' fillRule='nonzero'>
          <path d='M11.227 11.064a.544.544 0 0 0 .394.163c.15 0 .286-.054.395-.163l3.67-3.67a.36.36 0 0 0 .067-.081s.014-.014.014-.028a.297.297 0 0 1 .04-.068c0-.013 0-.027.014-.027.014-.027.014-.04.028-.068.013-.04.013-.068.013-.108 0-.041 0-.068-.013-.11a.104.104 0 0 0-.028-.067c0-.014 0-.027-.013-.027l-.041-.082s0-.013-.014-.013a.36.36 0 0 0-.068-.082l-3.67-3.67a.558.558 0 0 0-.788.788l2.719 2.719H4.282a.551.551 0 0 0-.558.557c0 .313.245.557.558.557h9.664l-2.719 2.719c-.217.19-.217.544 0 .761z' />
          <path d='M.612 13.932h7.34a.551.551 0 0 0 .557-.557v-3.167a.551.551 0 0 0-.558-.558.551.551 0 0 0-.557.558v2.61H1.17V1.167h6.225v2.747c0 .312.245.557.557.557a.551.551 0 0 0 .558-.557V.612A.551.551 0 0 0 7.95.054H.611a.551.551 0 0 0-.557.558v12.763a.569.569 0 0 0 .558.557z' />
        </g>
      </svg>
    </div>
  );
};
